import { cn } from '@/lib/cn';
import { posterGradient } from '@/lib/posters';
import { Clapperboard } from '@/components/icons';

/**
 * Stand-in artwork for any show/episode without an uploaded image yet.
 * Branded gradient + texture + a red "PLACEHOLDER" badge so it's obviously
 * temporary (spec §2 / owner request).
 */
export function ArtworkPlaceholder({
  seed,
  title,
  label = 'Placeholder',
  className,
}: {
  seed: string;
  title?: string;
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn('absolute inset-0 overflow-hidden', className)}
      style={{ backgroundImage: posterGradient(seed) }}
      aria-hidden="true"
    >
      {/* texture: diagonal hatch + soft top light */}
      <div
        className="absolute inset-0 opacity-[0.10]"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg, rgba(255,255,255,0.9) 0 1.5px, transparent 1.5px 14px)',
        }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(80%_55%_at_50%_0%,rgba(255,255,255,0.16),transparent_70%)]" />

      {/* faint motif */}
      <Clapperboard
        size={56}
        strokeWidth={1}
        className="absolute left-1/2 top-[44%] -translate-x-1/2 -translate-y-1/2 text-white/20"
      />

      {/* red PLACEHOLDER badge */}
      <span className="absolute left-1/2 top-3 -translate-x-1/2 whitespace-nowrap rounded-full bg-black/45 px-2.5 py-1 text-2xs font-bold uppercase tracking-[0.22em] text-red-400 ring-1 ring-red-500/40 backdrop-blur-sm">
        {label}
      </span>

      {title && (
        <span className="pointer-events-none absolute inset-x-2 top-1/2 text-center font-display text-xs font-semibold uppercase tracking-wide text-white/35">
          art coming soon
        </span>
      )}
    </div>
  );
}
